import '@angular/localize/init';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

declare global {
  interface Window {
    __cookieConsentConfig?: {
      enabled?: boolean;
      domainScriptId?: string;
      scriptUrl?: string;
    };
  }
}

window.__cookieConsentConfig = {
  enabled: environment.cookieConsent.enabled,
  domainScriptId: environment.cookieConsent.domainScriptId,
  scriptUrl: environment.cookieConsent.scriptUrl
};

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
